import _ from 'lodash';

const alphanumList = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export function randomAlphanums(len: number): string {
  return _.join(_.sampleSize(alphanumList, len), '');
}
